// 获取浏览器参数
const getQuery = function (name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
};

export const regOmoConfig = function () {
    let tkt = getQuery('tkt');
    let source = getQuery('source');
    let instance = getQuery('instance');
    if (source != 'omo' || !tkt || !instance) {
        return false;
    }
    return true;
};
//
export const getOmoParams = function (params) {
    return getQuery(params);
};
